import dropdownGenerator from './DropdownGenerator';

export default dropdownGenerator('small');
